import * as React from 'react';
import { AudioButton, AudioRecorderUseMode } from '../../../_components/AudioRecorder/AbstractAudioView';
import { PlaybackState } from '../../../_components/AudioRecorder/AudioPlayer';
import { RecordingState } from '../../../_components/AudioRecorder/MediaRecorder';
// import { AudioButton, AudioRecorderUseMode, PlaybackState, RecordingState } from '../../../_components/AudioRecorder';
import { PlayButton } from '../../../images/images';
import { colors } from '../../../styles/colors';
import { getRoundAudioButtonStyle, startStopButtonStyle } from './AudioStyles';

export function createStartButton(size: number): AudioButton {
    const outerButtonStyle = getRoundAudioButtonStyle(size);
    const innerButtonStyle = getRoundAudioButtonStyle((size = 18));
    return ({ playbackState, recordingState, mode, style, ...props }) => {
        if (mode === AudioRecorderUseMode.Recording && (recordingState === RecordingState.Paused || recordingState === RecordingState.Stopped)) {
            return (
                <div {...props} style={{ ...startStopButtonStyle, ...style, ...outerButtonStyle }}>
                    <div style={{ ...innerButtonStyle, backgroundColor: colors.CANCEL_TEXT }} />
                </div>
            );
        } else if (playbackState === PlaybackState.Paused) {
            return (
                <div {...props} style={{ ...startStopButtonStyle, ...style, ...outerButtonStyle }}>
                    <img style={outerButtonStyle} src={PlayButton} />
                </div>
            );
        }
        return null;
    };
}



// WEBPACK FOOTER //
// ./src/Pages/PhotoViewer/Audio/StartButton.tsx